<section>
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse variant="warning" />
    <p class="body bold">Safety issue</p>
  </section>

  <p class="body mt-8" data-testid="remedial-work-required-message">
    The engineer found a safety issue with your appliance. Please resolve this and then call to rebook your visit.
  </p>

  <app-telephone-link
    phoneNumber="0333 000 4966"
    [largeFont]="true"
    class="mt-12"
    data-testid="remedial-work-phone-number"
    [useButtonOnMobile]="true"
    buttonLabel="Call to rebook"
  />
</section>
